import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsProperty } from '@kurtosys/types/query/options/IQueryOptionsProperty.js';

import { commonUtils } from '../../common/index.js';
import { getItem } from '../queryUtils/getItem.js';

import { BaseEntityQuery } from './base/BaseEntityQuery.js';

export class PropertyQuery extends BaseEntityQuery<IQueryOptionsProperty> {
	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsProperty {
		const {
			entityType,
			entityConditional,
			code,
			codeQuery,
			key,
			keyQuery,
			index,
			entityKey,
			entityIndex,
			options = {},
		} = this.queryOptions;
		return {
			entityType,
			entityConditional,
			code,
			codeQuery,
			key,
			keyQuery,
			index,
			entityKey,
			entityIndex,
			...(options.property || {}),
		};
	}
	cleanPropertyIfArray = (property: any): any => {
		const { index } = this.options;
		if (typeof index === 'number' && commonUtils.isArrayLike(property)) {
			return getItem({
				index,
				collection: property,
			});
		}
		return property;
	};
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { code, key } = this.options;
		return this.processEntities(executionOptions, (entity) => {
			const properties = entity && (entity.properties_pub || entity.properties);
			if (properties && properties[code]) {
				let property = properties[code].value;

				if (key === 'originalValue' && properties[code][key]) {
					property = properties[code][key];
				} else if (key !== 'originalValue') {
					property = properties[code][key || 'value'];
				}
				return this.cleanPropertyIfArray(property);
			}
		});
	}
}
